const K_WIDTH = 22;
const K_HEIGHT = 30;
import icon from '../../../../public/assets/img/test-icon.svg';

const greatPlaceStyle = {
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates
  position: 'absolute',
  width: K_WIDTH,
  height: K_HEIGHT,
  left: -K_WIDTH / 2,
  top: -K_HEIGHT / 2,

  // border: '3px solid #f44336',
  borderRadius: K_HEIGHT,
  // backgroundColor: 'blue',
  textAlign: 'center',
  color: '#3f51b5',
  fontSize: 16,
  fontWeight: 'bold',
  padding: 4,
  // backgroundImage: 'url("https://www.shoppias.com/wp-content/uploads/Marker-512.png")',
  backgroundImage: `url(${icon})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

export { greatPlaceStyle };
